export default function WhyChoose() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cost-Effective',
      desc: 'No recruitment costs, training expenses, or employee benefits. Pay only for the services you need.'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexible Duration',
      desc: 'Choose daily or yearly contracts based on your requirements. Scale up or down as needed.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trained Professionals',
      desc: 'All staff are pre-screened, trained, and experienced. We handle all HR and management aspects.'
    },
    {
      icon: 'ri-user-follow-line',
      title: 'On-Site Presence',
      desc: 'Staff work directly at your premises, becoming familiar with your specific needs and environment.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Dedicated Support',
      desc: 'Our management team ensures quality service and handles any staff-related issues promptly.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Easy Replacement',
      desc: 'If a staff member is unavailable, we provide immediate replacement to ensure continuity.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Why Choose Contract-Based Staff Deployment?
          </h2>
          <p className="text-xl text-gray-600">Flexible, Cost-Effective, and Reliable</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${benefit.icon} text-teal-500 text-4xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{benefit.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
